import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import React, {useEffect, useState } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com"
import Animation from "./Animation";
import useTranslation from '../Constant';

const Contact = ({darkMode}) => {
  const Constant = useTranslation()

  const [isLoading,setLoading] = useState(false)
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  const [data, setData] = useState({
    name:"",
    email:"",
    message:"",
    mob:""
  })
  const handleChange =(e)=>{
    const{ name,value }= e.target;
    setData((prev)=> ({...prev, [name]:value}))
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simple email and phone validators
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhone = (phone) => /^\d{10}$/.test(phone);

    // Check if all fields are filled
    const { name, email, message, mob } = data;

    // Check if all fields are filled
    if (!name || !email || !message || !mob) {
      toast.error("Please fill all fields.");
      setLoading(false);
      return;
    }
    if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address.");
      setLoading(false);
      return;
    }
  
    if (!isValidPhone(mob)) {
      toast.error("Mobile number must be exactly 10 digits.");
      setLoading(false);
      return;
    }
  
    const templateParams = {
      to_email: "mailto:rajuofficialk@gmail.com",
      message: `${data.message} \nPhone: ${data.mob}`,
      from_name: data.name,
      to_name: "Raju Singh",
      reply_to: data.email
    };

    // Send the email using emailjs
    emailjs.send("service_gl1y4ey", "template_j2k5k6o", templateParams, "TPPbd8aEko-gH0gUQ")
      .then(
        (response) => {
          setData({ name: "", email: "", message: "", mob: "" }); // Clear the form data
          setLoading(false);
          toast.success("Email sent successfully! Our team will contact you soon.");
          setData((prev)=>({...prev,
            name:"",
            email:"",
            message:"",
            mob:""}
          ))
        },
        (error) => {
          setLoading(false);
          console.log("Error in sending email", error);
          toast.error("Error in sending email. Please try again later.");
        }
      );
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileOrTablet(window.matchMedia("(max-width: 1024px)").matches);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  return (
    <div id="contact"
    className={  darkMode ? "bg-gray-100  pt-14" : "bg-[#192236] text-white pt-14"}
    >
      <motion.div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 " 
       initial="hidden"
      whileInView={"visible"}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },}}>
        <h2 className="text-5xl font-bold px-4 md:px-0 text-center z-0">Contact</h2>

        <div>
          <h4 className="mt-12 text-3xl font-semibold text-blue-500"> Connect with me</h4>
          <p className="text-gray-500 text-xl">
            If you want to know more about me or my work, or if you would just
            <br />
            like to say hello, send me a message. I'd love to hear from you.
          </p>
        </div>

        <div
         className="flex justify-between items-center md:items-stretch  flex-col md:flex-row pb-24"
         >
          <div className="w-full md:pr-8">
            <form>
              <div className="my-6">
                <label htmlFor="name" className={ darkMode ? "block mb-2 text-lg font-medium text-gray-900" : "block mb-2 text-lg font-medium text-white" }>  Name</label>
                <input type="text" onChange={(e)=>handleChange(e)} value={data.name} name="name"  id="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Enter your name" required />
              </div>

              <div className="mb-4">
                <label htmlFor="email" className={darkMode  ? "block mb-2 text-lg font-medium text-gray-900"  : "block mb-2 text-lg font-medium text-white" }>  Email</label>
                <input type="email" onChange={(e)=>handleChange(e)} name="email" value={data.email} id="email" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Enter your email" required />
              </div>

              <div className="mb-4">
                <label htmlFor="mob" className={darkMode  ? "block mb-2 text-lg font-medium text-gray-900"  : "block mb-2 text-lg font-medium text-white" }>  Mobile No</label>
                <input type="number" onChange={(e)=>handleChange(e)} name="mob" value={data.mob} id="mob" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Enter your Mobile No" required />
              </div>

              <div className="mb-4">
                <label htmlFor="message" className={ darkMode   ? "block mb-2 text-lg font-medium text-gray-900"   : "block mb-2 text-lg font-medium text-white" } >  Message</label>
                <textarea id="message" onChange={(e)=>handleChange(e)} value={data.message} name="message"  className="bg-gray-50 border border-gray-300 text-gray-900 h-28 w-full text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Enter your message" required />
              </div>

              <div className="flex justify-between ">
                <div className="underline">
                  <a href="mailto:rajuofficialk@gmail.com">
                    Send me email directly
                  </a>
                </div>

                <button type="button" onClick={handleSubmit} className={`bg-indigo-500 text-white px-4 py-2 w-40 rounded-md hover:bg-indigo-400`} style={{cursor : isLoading ? "not-allowed" : ""}}>
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </div>

            </form>
            
            {
              isMobileOrTablet && 
                <div>
                  <Animation darkMode={darkMode} isMobileOrTablet={isMobileOrTablet}/>
                </div>
            }

          </div>
          <div className="w-full flex flex-col md:items-end  mt-12 md:mt-6">
            <div className="w-full flex flex-row md:justify-end sm:justify-start">
              <div className="flex flex-row justify-between">
                <h1 className="text-3xl font-bold">Email:</h1>
                <a href="mailto:rajuofficialk@gmail.com" className="mb-12  mt-2 ml-5 font-semibold text-blue-700 block">  rajuofficialk@gmail.com</a>
              </div>
            </div>

            <div className="w-full flex flex-row md:justify-end sm:justify-start">
              <div className="flex flex-row justify-between">
                  <h1 className="text-3xl  font-bold">Address:</h1>
                  <a  href="mailto:rajuofficialk@gmail.com" className="mt-2 ml-6 mb-12 md:text-right font-semibold text-blue-700 block uppercase">  Mohali, Chandigarh  <br />  India</a>
              </div>
            </div>

            <div className="w-full flex flex-row md:justify-end sm:justify-start">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
                  <h1 className="text-3xl mt-4 font-bold mb-2 md:mb-0">Social</h1>
                  <ul className="flex  md:flex-row gap-2 space-y-2 md:space-y-0">
                    {Constant.contactLinks.map((el, index) => (
                      <a
                        key={index}
                        href={el.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer mt-4 md:mt-0 hover:scale-125 flex justify-center items-center md:ml-6"
                      >
                        <img alt={el.name} src={el.url} />
                      </a>
                    ))}
                  </ul>
                </div>
                </div>
         
            {
              !isMobileOrTablet && 
                <Animation darkMode={darkMode}/>
            }
          </div>

        </div>
      </motion.div>

      <div 
        className={
          darkMode
            ? "w-full bg-white text-black text-lg py-3 flex justify-center"
            : "w-full bg-gray-900 text-white text-lg py-3 flex justify-center"
        }
      >
       <a  className=" animate-breathe inline-block  text-blue-600  font-semibold   hover:text-red-500  transition duration-300"  
        href="/photo.JPG" target="_blank" rel="noopener noreferrer" title='View Profile Photo'>
          Made with <span  className="text-red-500 animate-breathe font-bold hover:text-red-900 transition duration-50">&#10084; </span>
          by Raju Singh</a>
      </div>

    </div>
  );
};

export default Contact;
